import * as i0 from '@angular/core';
import { Injectable, TemplateRef, Component, ViewChild, HostBinding, Input, EventEmitter, Directive, Output, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/cdk/overlay';
import { ConnectionPositionPair, OverlayModule } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';

var OverlayWidthStrategy;
(function (OverlayWidthStrategy) {
    OverlayWidthStrategy[OverlayWidthStrategy["AUTO"] = 0] = "AUTO";
    OverlayWidthStrategy[OverlayWidthStrategy["HOST"] = 1] = "HOST";
})(OverlayWidthStrategy || (OverlayWidthStrategy = {}));

class AihubDropdownPositionFactory {
    /**
     * set position to right of the view by default
     */
    rightPosition() {
        return [
            new ConnectionPositionPair({ originX: 'end', originY: 'top' }, { overlayX: 'start', overlayY: 'top' }, 16),
            new ConnectionPositionPair({ originX: 'end', originY: 'bottom' }, { overlayX: 'start', overlayY: 'bottom' }, 16)
        ];
    }
    bottomCenterPosition() {
        return [
            new ConnectionPositionPair({ originX: 'center', originY: 'bottom' }, { overlayX: 'center', overlayY: 'top' }),
            new ConnectionPositionPair({ originX: 'center', originY: 'bottom' }, { overlayX: 'center', overlayY: 'bottom' })
        ];
    }
    /**
     * position on bottom right fallback to bottom left
     */
    bottomRightPosition() {
        const bottomRight = new ConnectionPositionPair({ originX: 'end', originY: 'bottom' }, { overlayX: 'end', overlayY: 'top' });
        const topRight = new ConnectionPositionPair({ originX: 'end', originY: 'top' }, { overlayX: 'end', overlayY: 'bottom' });
        bottomRight.panelClass = 'dropdown--position__bottom-right';
        return [bottomRight, topRight];
    }
    bottomLeftPosition(fallback = true) {
        const bottomLeft = new ConnectionPositionPair({ originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' });
        bottomLeft.panelClass = 'dropdown--position__bottom-left';
        return [bottomLeft, this.topLeft()];
    }
    /**
     * top left position
     */
    topLeft() {
        const topLeft = new ConnectionPositionPair({ originX: 'start', originY: 'top' }, { overlayX: 'end', overlayY: 'bottom' });
        topLeft.panelClass = 'dropdown--position__top-left';
        return topLeft;
    }
    /**
     * bottom left position
     */
    bottomLeft() {
        const bottomLeft = new ConnectionPositionPair({ originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' });
        bottomLeft.panelClass = 'dropdown--position__bottom-left';
        return bottomLeft;
    }
    /**
     * top right position
     */
    topRight() {
        const topRight = new ConnectionPositionPair({ originX: 'end', originY: 'top' }, { overlayX: 'end', overlayY: 'bottom' });
        topRight.panelClass = 'dropdown--position__top-right';
        return topRight;
    }
    /**
     * bottom right position
     */
    bottomRight() {
        const bottomRight = new ConnectionPositionPair({ originX: 'end', originY: 'bottom' }, { overlayX: 'end', overlayY: 'top' });
        bottomRight.panelClass = 'dropdown--position__bottom-right';
        return bottomRight;
    }
    topLeftPosition() {
        return [
            new ConnectionPositionPair({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'top' }),
            new ConnectionPositionPair({ originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'bottom' })
        ];
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AihubDropdownPositionFactory, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AihubDropdownPositionFactory });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AihubDropdownPositionFactory, decorators: [{
            type: Injectable
        }] });

class AiHubDropdownOverlayComponent {
    positionFactory;
    rootTemplate;
    className = '';
    positionPairs;
    overlayWidthStrategy;
    constructor(positionFactory) {
        this.positionFactory = positionFactory;
    }
    set position(position) {
        this.positionPairs = position;
    }
    get position() {
        return this.positionPairs || this.positionFactory.bottomCenterPosition();
    }
    set widthStrategy(strat) {
        this.overlayWidthStrategy = strat;
    }
    get widthStrategy() {
        return this.overlayWidthStrategy || OverlayWidthStrategy.AUTO;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AiHubDropdownOverlayComponent, deps: [{ token: AihubDropdownPositionFactory }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AiHubDropdownOverlayComponent, selector: "aihub-dropdown", inputs: { className: "className", position: "position", widthStrategy: "widthStrategy" }, host: { properties: { "class": "this.className" } }, viewQueries: [{ propertyName: "rootTemplate", first: true, predicate: ["rootTemplate"], descendants: true, read: TemplateRef, static: true }], ngImport: i0, template: "<ng-template #rootTemplate>\r\n    <ng-content></ng-content>\r\n</ng-template>", styles: [":host ::ng-deep ul{margin:0;padding:0}\n"] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AiHubDropdownOverlayComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aihub-dropdown', template: "<ng-template #rootTemplate>\r\n    <ng-content></ng-content>\r\n</ng-template>", styles: [":host ::ng-deep ul{margin:0;padding:0}\n"] }]
        }], ctorParameters: function () { return [{ type: AihubDropdownPositionFactory }]; }, propDecorators: { rootTemplate: [{
                type: ViewChild,
                args: ['rootTemplate', { static: true, read: TemplateRef }]
            }], className: [{
                type: HostBinding,
                args: ['class']
            }, {
                type: Input
            }], position: [{
                type: Input
            }], widthStrategy: [{
                type: Input
            }] } });

var ToggleState;
(function (ToggleState) {
    ToggleState[ToggleState["CLOSED"] = 0] = "CLOSED";
    ToggleState[ToggleState["OPEN"] = 1] = "OPEN";
})(ToggleState || (ToggleState = {}));
class AihubDropdownTriggerDirective {
    hostEl;
    viewContainerRef;
    overlay;
    renderer;
    aihubDropdown;
    stateChange;
    currentState = ToggleState.CLOSED;
    overlayRef;
    constructor(hostEl, viewContainerRef, overlay, renderer) {
        this.hostEl = hostEl;
        this.viewContainerRef = viewContainerRef;
        this.overlay = overlay;
        this.renderer = renderer;
        this.stateChange = new EventEmitter();
    }
    close() {
        if (!this.overlayRef) {
            return;
        }
        this.closeOverlay();
    }
    open() {
        if (this.overlayRef) {
            return;
        }
        this.openOverlay();
    }
    toggleOverlay() {
        this.currentState === ToggleState.CLOSED
            ? this.openOverlay()
            : this.closeOverlay();
        this.stateChange.emit(this.currentState);
    }
    onClick(event, targetElement) {
        if (!this.overlayRef || !targetElement) {
            return;
        }
        let clickedOutside = !this.overlayRef.overlayElement.contains(targetElement);
        clickedOutside = clickedOutside && !this.hostEl.nativeElement.contains(targetElement);
        clickedOutside = clickedOutside && targetElement !== this.hostEl.nativeElement;
        if (clickedOutside) {
            this.closeOverlay();
        }
    }
    ngOnInit() {
        this.renderer.addClass(this.hostEl.nativeElement, 'collapsed');
    }
    ngOnDestroy() {
        this.stateChange.complete();
        this.stateChange = null;
        this.closeOverlay();
    }
    /**
     * open overlay
     */
    openOverlay() {
        this.overlayRef = this.overlay.create({
            width: this.aihubDropdown.widthStrategy === OverlayWidthStrategy.HOST ? this.hostEl.nativeElement.offsetWidth : 'auto',
            panelClass: this.aihubDropdown.className,
            backdropClass: '',
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            positionStrategy: this.getOverlayPosition()
        });
        const template = new TemplatePortal(this.aihubDropdown.rootTemplate, this.viewContainerRef);
        this.overlayRef.attach(template);
        this.currentState = ToggleState.OPEN;
        this.renderer.removeClass(this.hostEl.nativeElement, 'collapsed');
        this.stateChange.emit(this.currentState);
    }
    /**
     * close overlay
     */
    closeOverlay() {
        if (this.overlayRef) {
            this.overlayRef.detach();
            this.overlayRef = null;
            this.currentState = ToggleState.CLOSED;
            this.renderer.addClass(this.hostEl.nativeElement, 'collapsed');
            this.stateChange.emit(this.currentState);
        }
    }
    getOverlayPosition() {
        return this.overlay
            .position()
            .flexibleConnectedTo(this.hostEl.nativeElement)
            .withPositions(this.aihubDropdown.position)
            .withFlexibleDimensions(false)
            .withPush(false);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AihubDropdownTriggerDirective, deps: [{ token: i0.ElementRef }, { token: i0.ViewContainerRef }, { token: i1.Overlay }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: AihubDropdownTriggerDirective, selector: "[aihubDropdown]", inputs: { aihubDropdown: "aihubDropdown" }, outputs: { stateChange: "stateChange" }, host: { listeners: { "click": "toggleOverlay()", "document:click": "onClick($event,$event.target)" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AihubDropdownTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[aihubDropdown]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: i1.Overlay }, { type: i0.Renderer2 }]; }, propDecorators: { aihubDropdown: [{
                type: Input
            }], stateChange: [{
                type: Output
            }], toggleOverlay: [{
                type: HostListener,
                args: ['click']
            }], onClick: [{
                type: HostListener,
                args: ['document:click', ['$event', '$event.target']]
            }] } });

class AihubDropdownModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AihubDropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: AihubDropdownModule, declarations: [AiHubDropdownOverlayComponent,
            AihubDropdownTriggerDirective], imports: [CommonModule,
            OverlayModule], exports: [AiHubDropdownOverlayComponent,
            AihubDropdownTriggerDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AihubDropdownModule, providers: [
            AihubDropdownPositionFactory
        ], imports: [CommonModule,
            OverlayModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AihubDropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AiHubDropdownOverlayComponent,
                        AihubDropdownTriggerDirective
                    ],
                    imports: [
                        CommonModule,
                        OverlayModule
                    ],
                    exports: [
                        AiHubDropdownOverlayComponent,
                        AihubDropdownTriggerDirective
                    ],
                    providers: [
                        AihubDropdownPositionFactory
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AiHubDropdownOverlayComponent, AihubDropdownModule, AihubDropdownPositionFactory, AihubDropdownTriggerDirective, OverlayWidthStrategy, ToggleState };
